import { Hashids } from './hashids.js';

const encode = function (value) {
  let {
    salt = null,
    length = 32
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return new Hashids(salt, length).encode(value);
};
const decode = function (value) {
  let {
    salt = null
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return new Hashids(salt).decode(value)[0];
};

export { decode, encode };
